export abstract class Animations {
  public static readonly DEFAULT_TRANSITION = '0.15s ease-in-out';
  public static readonly SUBTLE = '0.05s ease-in-out';
  public static readonly ANIME_SHARE_BOUNCE = {
    translateY: [-5, 0, -2.5, 0, -0.5, 0],
    easing: 'linear',
    duration: 1000,
  };
  public static readonly ANIME_SLIDE_DOWN = {
    translateY: [-5, -2.5, 0],
    easing: 'linear',
    duration: 500,
  };
  public static readonly ANIME_SLIDE_UP = {
    translateY: [0, -2.5, -5],
    easing: 'linear',
    duration: 500,
  };
  public static readonly ANIME_FADE_IN = {
    opacity: [0, 1],
    easing: 'linear',
    duration: 500,
  };
  public static readonly ANIME_FADE_OUT = {
    opacity: [1, 0],
    easing: 'linear',
    duration: 500,
  };
  public static readonly ANIME_SLIDE_OUT = {
    translateX: [0, 5000],
    easing: 'linear',
    duration: 500,
  };
}
